import GrantList, {
    GrantColumnHeadings,
    GrantListRow,
} from '~/components/packages/GrantList';
import { PackageTypes } from '~/lib/PackageHelpers';
import React, { forwardRef } from 'react';

const AllPackageGrants = forwardRef(
    ({ packages, type, singular, plural }, ref) => {
        return (
            <div className="max-w-4xl">
                <GrantList
                    search={{ type: type }}
                    plural={plural}
                    ref={ref}
                    showFilters={true}
                    headerContent={({ showNewGrant }) => (
                        <>
                            <GrantColumnHeadings
                                showPackageName={true}
                                nameHeading={singular}
                                isRenewing={type === PackageTypes.SUBSCRIPTION}
                            />
                        </>
                    )}
                    rowContent={({ grant }) => (
                        <GrantListRow
                            grant={grant}
                            showPackageName={true}
                            isRenewing={type === PackageTypes.SUBSCRIPTION}
                        />
                    )}
                />
            </div>
        );
    },
);

export default AllPackageGrants;
